// extracted by mini-css-extract-plugin
module.exports = {"container":"orders_container__1ddls","tabBadge":"orders_tabBadge__h-7GH"};